import type { MouseEvent } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Button } from "@similarweb/ui-components";

type Props = {
    onClick: (event?: MouseEvent<HTMLElement>) => void;
};

const TogglePanelButton = ({ onClick }: Props) => {
    const { translate } = useTranslate();

    return (
        <Button
            dataAutomation="filter-panel.show-more-button"
            type="flat"
            onClick={onClick}
        >
            {translate(`si.lead_gen_filters.show-more-button.label`)}
        </Button>
    );
};

export default TogglePanelButton;
